<div class="card">
  <div class="card-body">
    <h5>{{ "DANH SÁCH ĐƠN ĐÃ HOÀN TIỀN" | translate }}</h5>

    <div class="row refund-filters">
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-is-replaced">{{ "Tình trạng hóa đơn" | translate }}</label>
        <ng-select labelForId="refund-is-replaced" [(ngModel)]="filter.isReplaced" [clearable]="true" (change)="onInvoiceStatusChange()">
          <ng-option value="">Tất cả</ng-option>
          <ng-option value="-1">Chưa có hóa đơn gốc</ng-option>
          <ng-option value="0">Chưa có hóa đơn thay thế</ng-option>
          <ng-option value="1">Đã có hóa đơn thay thế</ng-option>
        </ng-select>
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-phone">{{ "Số điện thoại" | translate }}</label>
        <input id="refund-phone" type="text" class="form-control" [(ngModel)]="filter.phone" placeholder="Nhập số điện thoại" />
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-terminalBankAcc">{{ "Số tài khoản" | translate }}</label>
        <input id="refund-terminalBankAcc" type="text" class="form-control" [(ngModel)]="filter.terminalBankAcc" placeholder="Nhập số tài khoản" />
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-recipientPhone">{{ "SĐT người nhận" | translate }}</label>
        <input id="refund-recipientPhone" type="text" class="form-control" [(ngModel)]="filter.recipientPhone" placeholder="Nhập SĐT người nhận" />
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-mbReferenceNumber">{{ "Mã giao dịch gốc" | translate }}</label>
        <input id="refund-mbReferenceNumber" type="text" class="form-control" [(ngModel)]="filter.mbReferenceNumber" placeholder="Nhập mã giao dịch gốc" />
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-ftCodeRefund">{{ "Mã giao dịch hoàn tiền" | translate }}</label>
        <input id="refund-ftCodeRefund" type="text" class="form-control" [(ngModel)]="filter.ftCodeRefund" placeholder="Nhập mã giao dịch hoàn tiền" />
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-invoiceNo">{{ "Số hóa đơn gốc" | translate }}</label>
        <input id="refund-invoiceNo" type="text" class="form-control" [(ngModel)]="filter.invoiceNo" placeholder="Nhập số hóa đơn gốc" [disabled]="filter.isReplaced === '-1'" />
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <label for="refund-replaceInvoiceNo">{{ "Số hóa đơn thay thế" | translate }}</label>
        <input id="refund-replaceInvoiceNo" type="text" class="form-control" [(ngModel)]="filter.replaceInvoiceNo" placeholder="Nhập số hóa đơn thay thế" [disabled]="filter.isReplaced === '-1' || filter.isReplaced === '0'" />
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Khoảng ngày hoàn tiền</mat-label>
          <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
            <input matStartDate formControlName="start" placeholder="Ngày bắt đầu" />
            <input matEndDate formControlName="end" placeholder="Ngày kết thúc" />
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
          <mat-error *ngIf="range.invalid">Khoảng ngày hoàn tiền không hợp lệ</mat-error>
        </mat-form-field>
      </div>
      <div class="form-group col-12 col-sm-6 col-lg-3 d-flex align-items-center">
        <button class="btn btn-primary" (click)="submitFilter()">{{ "PAGE.REPORT.Search" | translate }}</button>
        <button class="btn btn-dark ml-2" *ngIf="searching" (click)="clearFilter()">{{ "FORM.Clear" | translate }}</button>
      </div>
    </div>
    <div class="refund-totals mb-3" aria-live="polite">
      <strong>{{ "Tổng số" | translate }}: {{ totalRefundTransactions | number : '1.0-0' : 'en-US' }}</strong>
      <strong>{{ "Tổng số tiền hoàn" | translate }}: {{ totalRefundAmount | number : '1.0-0' : 'en-US' }} đ</strong>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline return-confirm-table"
      >
        <colgroup>
          <col style="width: 45px" />
          <col style="width: 75px" />
          <col style="width: 200px" />
          <col style="width: 180px" />
          <col style="width: 160px" />
          <col style="width: 160px" />
          <col style="width: 220px" />
          <col style="width: 200px" />
          <col style="width: 200px" />
          <col style="width: 240px" />
          <col style="width: 120px" />
        </colgroup>
        <thead>
          <tr class="bg-table">
            <th>{{ "#" | translate }}</th>
            <th>{{ "Quản lý" | translate }}</th>
            <th>{{ "Thông tin GD hoàn tiền" | translate }}</th>
            <th>{{ "Thông tin HĐ thay thế" | translate }}</th>
            <th>{{ "Số tiền gốc" | translate }}</th>
            <th>{{ "Thông tin HĐ gốc" | translate }}</th>
            <th>{{ "Thông tin hủy" | translate }}</th>
            <th>{{ "Thông tin cửa hàng" | translate }}</th>
            <th>{{ "Thông tin khách hàng" | translate }}</th>
            <th>{{ "Thông tin tài khoản" | translate }}</th>
            <th>{{ "Thông tin gói DV" | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of listData; let i = index">
            <td class="table-column">{{ pageSize * (pageIndex - 1) + i + 1 }}</td>
            <td class="py-2 table-column">
              <div class="d-flex" style="gap: 5px">
                <a
                  class="font-size-18 text-primary"
                  *ngIf="data.is_replaced === 0"
                  ngbTooltip="{{ 'Tạo hoá đơn thay thế' | translate }}"
                  container="body"
                  placement="top"
                  (click)="onEdit(data, updateInvoice)"
                >
                  <i class="mdi mdi-refresh"></i>
                </a>
              </div>
            </td>
            <td class="table-column">
              <div>
                <span *ngIf="+data.amount_refund" class="badge amount-badge">{{ data.amount_refund | number : '1.0-0' }}</span>
                <ng-container *ngIf="+data.amount_refund && data.refund_date"> - </ng-container>
                {{ data.refund_date ? (data.refund_date | date : 'dd/MM/yyyy') : '' }}
              </div>
              <div>{{ data.ftCode_refund || '' }}</div>
            </td>
            <td class="table-column">
              <div>
                <button *ngIf="data.replace_invoice_no" type="button"
                  class="btn btn-link p-0 text-left"
                  (click)="previewInvoice(data.replace_invoice_no, invoicePreviewModal)">
                  {{ data.replace_invoice_no }}
                </button>
              </div>
              <div>{{ data.replace_invoice_date ? (data.replace_invoice_date | date : 'dd/MM/yyyy HH:mm:ss') : '' }}</div>
            </td>
            <td class="table-column">
              <div>
                <span class="badge amount-badge" *ngIf="(data.amount != null ? +data.amount : (+data.discounted_price || 0) + (+data.fix_ship_fee || 0))">
                {{ (data.amount != null ? +data.amount : (+data.discounted_price || 0) + (+data.fix_ship_fee || 0)) | number : '1.0-0' }}
                </span>
              </div>
              <div>{{ data.mb_reference_number || '' }}</div>
            </td>
            <td class="table-column">
              <div>
                <button *ngIf="data.invoice_no" type="button"
                  class="btn btn-link p-0 text-left"
                  (click)="previewInvoice(data.invoice_no, invoicePreviewModal)">
                  {{ data.invoice_no }}
                </button>
              </div>
              <div>{{ data.invoice_date ? (data.invoice_date | date : 'dd/MM/yyyy HH:mm:ss') : '' }}</div>
            </td>
            <td class="table-column">
              <div>{{ data.oc_requested_cancel_date ? (data.oc_requested_cancel_date | date : 'dd/MM/yyyy') : '' }}</div>
              <div>{{ data.oc_reason || '' }}</div>
            </td>
            <td class="table-column">
              <div>{{ data.workspace_code || '' }}</div>
              <div>{{ data.workspace_name || '' }}</div>
            </td>
            <td class="table-column">
              <div>{{ data.user_phone || '' }}</div>
              <div>{{ data.full_name || '' }}</div>
            </td>
            <td class="table-column">
              <div>{{ data.terminal_bank_acc || '' }}</div>
              <div>{{ data.terminal_bank_acc_name || '' }}</div>
            </td>
            <td class="table-column">
              <div>
                <span *ngIf="data.device_name || data.quantity != null" class="badge font-size-12" [ngClass]="{
                  'badge-info': data.device_name === 'Loa 4G',
                  'badge-primary': data.device_name === 'Loa WIFI',
                  'badge-secondary': data.device_name !== 'Loa 4G' && data.device_name !== 'Loa WIFI'
                }">{{ data.device_name }}<ng-container *ngIf="data.device_name && data.quantity != null"> x </ng-container>{{ data.quantity }}</span>
              </div>
              <div class="mt-1">
                <span
                  class="badge font-size-12"
                  [ngClass]="{
                    'badge-secondary': data.original_duration == 3,
                    'badge-info': data.original_duration == 6,
                    'badge-warning': data.original_duration == 12,
                    'badge-success': data.original_duration == 60,
                    'badge-dark':
                      data.original_duration != 3 &&
                      data.original_duration != 6 &&
                      data.original_duration != 12 &&
                      data.original_duration != 60
                  }"
                  *ngIf="data.original_duration"
                  >{{ data.original_duration }} tháng</span
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row justify-content-md-between align-items-md-center mt-2">
      <div class="col-sm-12 col-md-5">
        <div
          class="dataTables_info mb-2"
          id="tickets-table_info"
          role="status"
          aria-live="polite"
        >
          {{ "TABLE.Showing" | translate }}
          {{ pageSize * pageIndex - pageSize + 1 }}
          {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
          {{ "TABLE.of" | translate }} {{ totalCount }}
          {{ "TABLE.entries" | translate }}
        </div>
      </div>
      <!-- Pagination -->
      <div
        class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end"
      >
        <div class="text-md-right float-md-right pagination-rounded">
          <ngb-pagination
            [collectionSize]="totalCount"
            [(page)]="pageIndex"
            [pageSize]="pageSize"
            [maxSize]="5"
            [ellipses]="true"
            (pageChange)="fetchData()"
          >
          </ngb-pagination>
        </div>
        <div class="dataTables_length ml-3" id="tickets-table_length">
          <label class="d-inline-flex align-items-center mb-0">
            {{ "TABLE.Show" | translate }}
            <select
              name="tickets-table_length"
              aria-controls="tickets-table"
              name="pageSize"
              [(ngModel)]="pageSize"
              (ngModelChange)="pageIndex = 1; fetchData()"
              class="custom-select custom-select-sm form-control form-control-sm mx-2"
            >
              <option [ngValue]="10">10</option>
              <option [ngValue]="25">25</option>
              <option [ngValue]="50">50</option>
              <option [ngValue]="100">100</option>
            </select>
            {{ "TABLE.entries" | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">
      {{ (formData.value.id ? "FORM.Edit" : "FORM.AddNew") | translate }}
    </h5>
    <!-- <div *ngIf="makeForm('password').hasError('required')" class="error-message">
                  Mật khẩu không được bỏ trống.
              </div> -->
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="saveData()" [formGroup]="formData">
        <div class="row">
          <!-- <div class="form-group row col-md-6">
                              <label class="col-md-2 col-form-label required_label">{{'Imei' | translate}}</label>
                              <div class="col-md-10">
                                  <input type="text" class="form-control" formControlName="imei"
                                      [ngClass]="{'is-invalid': submitted && form.imei.errors}" />
                                
                              </div>
                          </div> -->
          <!-- <div class="form-group row col-md-12" *ngIf="!formData.value.id"> -->

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Serial" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="serial_number"
                [ngClass]="{
                  'is-invalid': submitted && form.serial_number.errors
                }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md col-form-label required_label">{{
              "Model" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="model"
                [ngClass]="{ 'is-invalid': submitted && form.model.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listModel">
                  {{ item }}
                </option>
              </select>
              <!-- <input type="text" class="form-control" formControlName="model"
                                      [ngClass]="{'is-invalid': submitted && form.model.errors}" />
                                 -->
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Phiên bản" | translate
            }}</label>
            <div class="col-md-10">
              <select
                class="form-select"
                aria-label="Default select example"
                class="form-control"
                formControlName="version"
                [ngClass]="{ 'is-invalid': submitted && form.version.errors }"
              >
                <option value="{{ item }}" *ngFor="let item of listVersion">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
          <!-- <div class="form-group row col-md-12">
                              <label class="col-md-2 col-form-label required_label">{{'Trạng thái' | translate}}</label>
                              <div class="col-md-10">
                                  <select class="form-select" aria-label="Default select example" class="form-control" formControlName="status"  [ngClass]="{'is-invalid': submitted && form.status.errors}">
                                      <option value="0" >Ngoại tuyến</option>
                                      <option value="1" >Trực tuyến</option>
                                  </select>
                              </div>
                          </div>   -->
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Lưu" | translate }}
          </button>
          <!-- <button type="button" class="btn btn-secondary btn-sm" style="width: 150px"
                          (click)="modal('close click')">{{'FORM.Close' | translate}}</button>
                      <button type="button" class="btn btn-primary btn-sm ml-3" style="width: 150px"
                          (click)="updateFormNote()">{{'FORM.Save' | translate}}</button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #updateInvoice role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Cập nhật hoá đơn thay thế và hoá đơn phí</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form
        (ngSubmit)="createReplacementInvoiceDraft(formData.value)"
        [formGroup]="formData"
      >
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-12 col-form-label required_label">
              {{ "Nhập giá tiền mới" | translate }}
            </label>
            <div class="col-md-12">
              <input
                type="number"
                class="form-control"
                formControlName="fee_amount"
                [ngClass]="{
                  'is-invalid':
                    submitted && formData.controls.fee_amount.invalid
                }"
              />
              <div
                *ngIf="submitted && formData.controls.fee_amount.invalid"
                class="invalid-feedback"
              >
                <div *ngIf="formData.controls.data.errors?.required">
                  Giá trị là bắt buộc.
                </div>
                <div *ngIf="formData.controls.data.errors?.min">
                  Giá trị phải không nhỏ hơn 1.
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <button
            type="submit"
            class="btn btn-success btn-lg"
            style="width: 150px"
          >
            {{ "Gửi" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<ng-template #contentDetail role="document" let-modal="close">
  <div class="modal-header">
    <h5 class="modal-title">Chi tiết đơn hàng Online</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="text-left">
      <form (ngSubmit)="deviceLink(formData.value)" [formGroup]="formData">
        <div class="row">
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Người nhận" | translate
            }}</label>
            <div class="col-md-10">
              <input
                type="text"
                class="form-control"
                formControlName="customer_name"
                [ngClass]="{
                  'is-invalid': submitted && form.customer_name.errors
                }"
                disabled
              />
            </div>
          </div>

          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Số điện thoại" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="phone"
                [ngClass]="{ 'is-invalid': submitted && form.phone.errors }"
              />
            </div>
          </div>
          <div class="form-group row col-md-12">
            <label class="col-md-2 col-form-label required_label">{{
              "Địa chỉ" | translate
            }}</label>
            <div class="col-md-10">
              <input
                disabled
                type="text"
                class="form-control"
                formControlName="address"
                [ngClass]="{ 'is-invalid': submitted && form.address.errors }"
              />
            </div>
          </div>
        </div>

        <div class="text-center">
          <button
            type="button"
            class="btn btn-secondary btn-lg mr-3"
            style="width: 150px"
            (click)="modal('close click')"
          >
            {{ "Đóng" | translate }}
          </button>
          <!-- <button
                type="submit"
                class="btn btn-success btn-lg"
                style="width: 150px;"
              >
                {{'Lưu' | translate}}
              </button> -->
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template #contentKeyword let-modalHis="close">
  <div class="modal-header">
    <h5 class="modal-title">List keyword of "{{ selectedIncident.name }}"</h5>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalHis('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-3">
    <div class="mb-3" *ngIf="formNewKeyword">
      <h5 class="font-size-14">Add New Keyword</h5>
      <form
        [formGroup]="formNewKeyword"
        (submit)="onSubmitFormKeyword(2)"
        class="d-flex"
      >
        <input
          type="text"
          class="form-control form-control-sm"
          style="width: 250px"
          formControlName="name"
        />
        <button class="btn btn-primary btn-sm ml-3" style="width: 150px">
          Add
        </button>
      </form>
    </div>
    <div class="table-responsive">
      <table
        id="basic-datatable"
        class="table table-bordered dt-responsive nowrap no-footer dtr-inline"
      >
        <thead>
          <tr>
            <th width="50">#</th>
            <th>Name</th>
            <!-- <th>Thời gian</th> -->
            <th width="170"></th>
          </tr>
        </thead>
        <tbody *ngFor="let data of dataKeyword; let i = index">
          <tr>
            <td class="table-column">{{ i + 1 }}</td>
            <td class="table-column">
              <ng-container
                *ngIf="
                  selectedKeyword?.id == data.id && formEditKeyword;
                  else normal
                "
              >
                <form
                  [formGroup]="formEditKeyword"
                  (submit)="onSubmitFormKeyword(1)"
                >
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    formControlName="name"
                  />
                </form>
              </ng-container>
              <ng-template #normal>{{ data.name }}</ng-template>
            </td>
            <!-- <td class=" table-column">{{data.created_at*1000 | date:'dd/MM/yyyy HH:mm'}}</td> -->
            <td class="table-column">
              <div class="d-flex" style="gap: 10px">
                <a
                  class="btn btn-sm btn-success"
                  href="javascript: void(0);"
                  (click)="editKeyword(data, i)"
                >
                  <i class="mdi mdi-account-edit"></i
                  >{{ "FORM.Edit" | translate }}</a
                >
                <a
                  class="text-white btn btn-sm btn-danger"
                  (click)="onDeleteKeyword(data.id)"
                  ><i class="mdi mdi-delete"></i
                  >{{ "FORM.Delete" | translate }}</a
                >
              </div>
              <!-- <button class="btn" (click)="editKeyword(data,i)">Sửa</button>
                                  <button>Xoá</button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>

<ng-template #invoicePreviewModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Hoá đơn: {{ previewInvoiceNo }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0 invoice-preview">
    <iframe *ngIf="invoicePdfUrl" [src]="invoicePdfUrl" title="Xem trước hóa đơn gốc"></iframe>
  </div>
</ng-template>
